import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const CloseIconCD = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig?.baseColors) return null

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 20L50 50"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M50 20L20 50"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle
        cx="35"
        cy="35"
        r="32.5"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="5"
      />
    </svg>
  )
}
export default CloseIconCD
